<!-- <app-header *ngIf="isDisplay" [isDisplayMenuButton]="isShowLogoutAndMenuIcon" [isFormBlur]="isFormBlur"
    [userInfo]="userInfo" (MenuClick)="isSidebarOpen=!isSidebarOpen" (LogoutClick)="logout()"
    (toggleGlobalModal)="toggleGlobalModal($event)"></app-header> -->

<div class="main_content">
    <div #page_section class="page_main_sec">
        <div class="dashboard_main_sec">
            <div [formGroup]="frmControlPanel" class="">
                <!-- <div style="height: 190px !important;" class="post-nav-wrap"> -->
                <div class="post-nav-wrap">
                    <div class="title-wrap">
                        <h1 class="title">Workflow Dashboard</h1>
                    </div>
                </div>
                <div class="shadowBox cardM">

                    <ul class="inactivityRep">
                        <li class="active">
                            <div class="input-field">
                                <mat-form-field appearance="legacy" [style.width.%]="100">
                                    <mat-label for="category">Category <span
                                            class="field-mandatory">*</span></mat-label>
                                    <mat-select [formControlName]="'documenttypeselected'"
                                        (selectionChange)="changeQueue()" id="category" [attr.role]="null">

                                        <mat-option [value]="doc.document_type_id" *ngFor="let doc of lstDocumentType">
                                            {{doc.document_type_name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="input-field" *ngIf="ImprovementCategoryFLag">
                                <mat-form-field appearance="legacy" [style.width.%]="100">
                                    <mat-label for="improvement_category">Improvement Category <span
                                            class="field-mandatory">*</span></mat-label>
                                    <mat-select [formControlName]="'categorytypeselected'"
                                        (selectionChange)="changeQueue()" id="improvement_category" [attr.role]="null">

                                        <mat-option [value]="doc.improvement_scope"
                                            *ngFor="let doc of lstImprovementType">
                                            {{doc.improvement_scope}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </li>
                        <li *ngIf="commonService.selectedIsInitiator==1 ? true: false;" class="active">
                            <span class="icon iconLatestdoc cgx-i cgx-i_SeoCalculator"></span><span
                                class="card06Tl">Total Ideas</span>
                            <span class="cCount">
                                <div class="tabBtn" type="button">
                                    <span class="cCount">{{total}}</span>
                                </div>
                            </span>
                        </li>
                        <li *ngIf="commonService.selectedIsInitiator==0 ? true: false;" class="active">
                            <span class="icon iconLatestdoc cgx-i cgx-i_SeoCalculator"></span><span
                                class="card06Tl">Total Ideas</span>
                            <span class="cCount" (click)="onSelectFilterWorkList(2)">
                                <div class="tabBtn" type="button">
                                    <span class="cCount">{{total}}</span>
                                </div>
                            </span>
                        </li>
                        <!-- <li *ngIf="commonService.selectedIsimplementation==1 ? true: false;"  class="active"> -->
                        <li *ngIf="commonService.selectedIsimplementation==1 ? true: false;" class="active">
                            <span class="icon iconLatestdoc cgx-i cgx-i_Atom"></span><span
                                class="card06Tl">Implementable Ideas</span>
                            <span class="cCount" (click)="onSelectFilterWorkList(2)">
                                <div class="tabBtn" type="button">
                                    <span class="cCount">{{implementableideas}}</span>
                                </div>
                            </span>
                        </li>

                        <li *ngIf="commonService.selectedIsimplementation==1 ? false: true;" class="active">
                            <span class="icon iconLatestdoc cgx-i cgx-i_TargetAudience"> </span>
                            <span class="card06Tl">My Ideas</span>
                            <span class="cCount" (click)="onSelectFilterWorkList(3)">
                                <div class="tabBtn" type="button">
                                    <span class="cCount">{{getmyideas}}</span>
                                </div>
                            </span>
                        </li>

                        <!-- <li *ngIf="commonService.selectedIsimplementation==1 ? true: false;"   class="active">                        
                            <span class="icon iconLatestdoc cgx-i cgx-i_TargetAudience">       </span>
                            <span class="card06Tl">My Ideas</span>                        
                            <span  class="cCount">                         
                                <div class="tabBtn"  type="button" >
                                    <span class="cCount">{{getmyideas}}</span>                           
                                </div>  
                            </span> 
                        </li>   -->


                        <li class="active"><span class="icon iconLatestdoc cgx-i cgx-i_Success">

                            </span><span class="card06Tl">Idea Winner</span><span class="cCount">{{ideawinner}}</span>
                        </li>

                    </ul>
                </div>


                <div class="serviceChainWrp shadowBox">

                    <h3 style="margin-left: 20px !important;" class="subTitle01-1">Ideas Value Chain</h3>
                    <div class="serviceChainValueWrp timeline hrztal">
                        <div class="valueChainWrp">
                            <div class="valueCol start">
                                <div class="valueIcnWrp CGX-GY-40L"><span class="cgx-i cgx-i-m cgx-i_Gear"></span></div>
                                <svg class="connector CGX-GY-90L" width="71.044" height="71.044"
                                    viewbox="0 0 71.044 71.044">
                                    <path id="Path_47234" data-name="Path 47234"
                                        d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                        transform="translate(-0.876 -1.564)"></path>
                                </svg>
                            </div>

                            <ng-container *ngFor="let process of lstProcessQueue, index as i">
                                <div *ngIf="!process.isimplementation_queue" class="valueCol"
                                    (click)="onDetailTileClick(process.processName,process.documentList[i])">
                                    <div [ngClass]="'valueIcnWrp CGX-BL-00'+(i % 6)" matTooltip = {{process.Tooltip}}
                                     matTooltipPosition="right" [matTooltipClass] = "'Custom_Css'"><span
                                            [ngClass]="lstProcessClassesForTiles[(i%9)]"></span>
                                    </div>
                                    <h4 class="subTitle03">{{process.processName}}</h4>
                                    <span [ngClass]="'vCount CGX-BL-00'+(i%6)">{{
                                        process.count}}</span>

                                    <svg class="connector CGX-GY-90L" width="71.044" height="71.044"
                                        viewbox="0 0 71.044 71.044">
                                        <path [id]="'Path_47234'+i" data-name="'Path 47234'+i"
                                            d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                            transform="translate(-0.876 -1.564)"></path>
                                    </svg>
                                </div>
                            </ng-container>

                            <ng-container *ngFor="let process of ProcessList, index as i">
                                <div *ngIf="lstProcessQueue ==undefined || lstProcessQueue.length==0" class="valueCol">
                                    <div [ngClass]="'valueIcnWrp CGX-BL-00'+(i % 6)"><span
                                            [ngClass]="lstProcessClassesForTiles[(i%9)]"></span>
                                    </div>
                                    <h4 class="subTitle03">{{process.process_name}}</h4>
                                    <span [ngClass]="'vCount CGX-BL-00'+(i%6)">0</span>

                                    <svg class="connector CGX-GY-90L" width="71.044" height="71.044"
                                        viewbox="0 0 71.044 71.044">
                                        <path [id]="'Path_47234'+i" data-name="'Path 47234'+i"
                                            d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                            transform="translate(-0.876 -1.564)"></path>
                                    </svg>
                                </div>
                            </ng-container>

                            <!-- <div class="valueCol end">
                                <div class="valueIcnWrp CGX-GY-00N"><span class="cgx-i cgx-i-m cgx-i_DestinationMap"></span></div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="serviceChainWrp shadowBox">
                    <h3 style="margin-left: 20px !important;" class="subTitle01-1">Implementation Value Chain</h3>
                    <!-- <div class="serviceChainValueWrp exptn"> -->
                    <div class="serviceChainValueWrp timeline hrztal">
                        <div class="valueChainWrp">
                            <ng-container *ngFor="let process of lstProcessQueue, index as i">
                                <div *ngIf="process.isimplementation_queue" class="valueCol"
                                    (click)="onDetailTileClick(process.processName,process.documentList[i])">
                                    <div [ngClass]="'valueIcnWrp CGX-BL-00'+(i % 6)" 
                                    matTooltip = {{process.Tooltip}}
                                     matTooltipPosition="right" [matTooltipClass] = "'Custom_Css'"><span
                                            [ngClass]="lstProcessClassesForTiles[(i%9)]"></span>
                                    </div>
                                    <h4 class="subTitle03">{{process.processName}}</h4>
                                    <span [ngClass]="'vCount CGX-BL-00'+(i%6)">{{process.count}}</span>

                                    <svg class="connector CGX-GY-90L" width="71.044" height="71.044"
                                        viewbox="0 0 71.044 71.044">
                                        <path [id]="'Path_47234'+i" data-name="'Path 47234'+i"
                                            d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                            transform="translate(-0.876 -1.564)"></path>
                                    </svg>
                                </div>

                            </ng-container>

                            <div class="valueCol end">
                                <div class="valueIcnWrp CGX-GY-00N"><span
                                        class="cgx-i cgx-i-m cgx-i_DestinationMap"></span></div>
                            </div>
                        </div>

                    </div>

                </div>

                <!-- URN Search grid -->
                <div *ngIf="isDisplaySearchGrid">
                    <app-advance-gridview [lstData]="lstTransaction_search" [lstHeaders]="lstHeader_search"
                        [gridTitle]="'Search result for URN '+searchURN" [showColumnGroup]="true"
                        [showAdvanceSearchOption]="false" [showExcelDownloadOption]="false"
                        identityColumnName="DOCUMENT_DETAIL_ID" (cellClickEvent)="cellClickEvent($event)"
                        (columnsFilterChangeEvent)="columnsFilterChangeEvent($event)"></app-advance-gridview>
                </div>

                <div *ngIf="lstProcessData==undefined || lstProcessData.length ==0">
                    <div class="row col s12">
                        <span style="text-align: center;padding-top: 10px;">No record found.</span>
                    </div>

                </div>
                <!-- Process & Document Type list & txn count -->
                <div class="tab-content">
                    <div>
                        <div *ngIf="viewType=='TABULAR'">
                            <div class="table_header_sec">
                                <!-- <h4 class="page_inner_title">Queue & Work Item Type wise Invoice count</h4> -->
                                <div class="page_search_main_sec">
                                    <div class="page_search_expand">
                                        <div class="p_urn_sec">
                                            <img src="/assets/img/arrow-bar-right.svg" class="mr-2" alt="Arrow">
                                            <span>URN</span>
                                        </div>
                                        <div class="urn_input_sec">
                                            <input type="text" class="p_urn_search" title="URN Search"
                                                value="BSR_20210708_402">
                                            <img src="/assets/img/cancel-icon.png" alt="Cancel"
                                                class="p_urn_cancel_icon">
                                        </div>
                                        <div class="urn_search_btn_sec">
                                            <img src="/assets/img/search_quick.svg" class="mr-2" alt="Search">
                                            <span>Search</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- Tile View: (Process > Document Type)-->
                        <div *ngIf="viewType=='TILE' && !flipProcess" class="row stats-bx-wrap">
                            <ng-container *ngFor="let process of lstProcessQueue;let bxIndex=index">
                                <div *ngIf="bxIndex < 6" [class.stats-active]="activeProcess==process.processId"
                                    (click)="loadStatDrop('process',process,$event)" class="stats-bx">
                                    <p class="stat-title" title="{{process.processName}}">
                                        {{process.processName}}
                                    </p>
                                    <span class="stat-count">{{process.count}}</span>
                                    <span class="material-icons drop-icon">arrow_drop_down</span>
                                </div>
                            </ng-container>
                            <div *ngIf="showAllBx" class="collapsible-data flex">
                                <ng-container *ngFor="let process of lstProcessQueue;let bxIndex=index">
                                    <div *ngIf="bxIndex >= 6" [class.stats-active]="activeProcess==process.processId"
                                        (click)="loadStatDrop('process',process,$event)" class="stats-bx">
                                        <p class="stat-title" title="{{process.processName}}">
                                            {{process.processName}}
                                        </p>
                                        <span class="stat-count">{{process.count}}</span>
                                        <span class="material-icons drop-icon">arrow_drop_down</span>
                                    </div>
                                </ng-container>
                            </div>
                            <a *ngIf="viewType=='TILE' && lstProcessQueue.length>6" (click)="showAllBx=!showAllBx"
                                class="view-collapse">
                                <span *ngIf="showAllBx">
                                    <i class="material-icons">arrow_upward</i> View Less
                                </span>
                                <span *ngIf="!showAllBx">
                                    <i class="material-icons">arrow_downward</i> View More
                                </span>
                            </a>
                        </div>

                        <!-- Tile View: (Document Type > Process) -->
                        <div *ngIf="viewType=='TILE' && flipProcess" class="row stats-bx-wrap">

                            <ng-container *ngFor="let doc of lstDocumentQueue;let bxIndex=index">
                                <div *ngIf="bxIndex < 6" [class.stats-active]="activeDocument==doc.documentId"
                                    (click)="loadStatDrop('doc',doc,$event)" class="stats-bx">
                                    <p class="stat-title" title="{{doc.documentName}}">
                                        {{doc.documentName}}
                                    </p>
                                    <span class="stat-count">{{doc.count}}</span>
                                    <span class="material-icons drop-icon">arrow_drop_down</span>
                                </div>
                            </ng-container>
                            <div *ngIf="showAllBx" class="collapsible-data flex">
                                <ng-container *ngFor="let doc of lstDocumentQueue;let bxIndex=index">
                                    <div *ngIf="bxIndex >= 6" [class.stats-active]="activeDocument==doc.documentId"
                                        (click)="loadStatDrop('doc',doc,$event)" class="stats-bx">
                                        <p class="stat-title" title="{{doc.documentName}}">
                                            {{doc.documentName}}
                                        </p>
                                        <span class="stat-count">{{doc.count}}</span>
                                        <span class="material-icons drop-icon">arrow_drop_down</span>

                                    </div>
                                </ng-container>
                            </div>
                            <a *ngIf="viewType=='TILE' && lstDocumentQueue.length>6" (click)="showAllBx=!showAllBx"
                                class="view-collapse">
                                <span *ngIf="showAllBx">
                                    <i class="material-icons">arrow_upward</i> View Less
                                </span>
                                <span *ngIf="!showAllBx">
                                    <i class="material-icons">arrow_downward</i> View More
                                </span>
                            </a>

                        </div>

                    </div>
                </div>

                <div [style.display]="(viewType=='TILE' && showStatDrop)?'block':'none'" class="row">
                    <div #stateDrop class="col s12 stats-drop-wrp">
                        <span class="close-stat" (click)="showStatDrop=false">x</span>
                        <div class="stat-drop">
                            <ng-container>
                                <div class="stat-count-wrp" [class.active]="activeDocument==doc.documentId"
                                    *ngFor="let doc of lstStatDropProcess.documentList;let j=index"
                                    (click)="getSummaryData(doc,lstStatDropProcess,'')">
                                    <a><span class="drop-count m-bold">{{doc.count}}</span></a>
                                    <span>{{doc.documentName}}</span>
                                </div>

                                <div class="stat-count-wrp" [class.active]="activeProcess==process.processId"
                                    *ngFor="let process of lstStatDropDocument.processList"
                                    (click)="getSummaryData(lstStatDropDocument,process,'')">
                                    <a><span class="drop-count m-bold">{{process.count}}</span></a>
                                    <span>{{process.processName}}</span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>



            <!-- Transaction summary grid -->
            <div #summary_grid>
                <div class="" *ngIf="isDisplayTransactionData">
                    <app-advance-gridview [lstData]="lstTransaction" [lstHeaders]="lstHeaders" #gridTransactionData
                        [currentPage]="currentPage" [recordsPerPage]="recordsperPage"
                        [gridTitle]="'Process Name: ' + processName" [showColumnGroup]="true"
                        [showAdvanceSearchOption]="true" [advanceSearchFields]="advanceSearchSummaryFields"
                        [isOpenAdvanceSearch]="isOpenAdvanceSearch" [showExcelDownloadOption]="true"
                        identityColumnName="DOCUMENT_DETAIL_ID" (cellClickEvent)="cellClickEvent($event)"
                        (advanceSearchClickEvent)="advanceSearchClickEvent($event)"
                        (columnsFilterChangeEvent)="columnsFilterChangeEvent($event)"
                        (setPaginationLocalStorageEvent)="setPaginationLocalStorageEvent()"
                        [Isserversidepaginationenabled]="pageflag" (downloadalldata)="downloadalldata($event)">
                    </app-advance-gridview>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #filterOptionModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Filter Options</h5>
            <div>
                <button type="button" class="model_ok_btn" (click)="filterProcessData()">Apply</button>
                <button type="button" class="model_cancle_btn" (click)="modal.dismiss('Cross click')">Close</button>
            </div>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="">
                <div class="row">
                    <!-- (click)="$event.stopPropagation();" -->
                    <mat-checkbox class="chk-filter-persona filterCheck" [(ngModel)]="saveAsDefaultFilter">
                        Save as default
                    </mat-checkbox>
                    <div class="col-lg-6">
                        <div>
                            <span class="bx-sub-title">Work Item Type</span>
                            <ul class="selection-list">
                                <!-- <div class="col-lg-6"> -->
                                <li [class.selected]="filteredDoctypes.includes(0)" (click)="onSelectFilterDocument(0)">
                                    <div class="selected-check">All ({{getAllDoctypeCount()}})</div>
                                </li>
                                <!-- </div>
                            <div class="col-lg-6"> -->
                                <li *ngFor="let doc of lstDocumentTypeFilter"
                                    [class.selected]="filteredDoctypes.includes(doc.documentId)"
                                    (click)="onSelectFilterDocument(doc.documentId)">
                                    <div class="selected-check">{{doc.documentName}} ({{doc.count}})</div>
                                </li>
                                <!-- </div> -->
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div>
                            <span class="bx-sub-title">Queue</span>
                            <ul class="selection-list">
                                <li [class.selected]="filteredQueue.includes(0)" (click)="onSelectFilterQueue(0)">
                                    <div class="selected-check">All</div>
                                </li>
                                <li *ngFor="let process of ProcessList"
                                    [class.selected]="filteredQueue.includes(process.process_id)"
                                    (click)="onSelectFilterQueue(process.process_id)">
                                    <div class="selected-check">{{process.process_name}}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row advance-search-wrp">
                    <div *ngIf="frmFilterSearch">
                        <div class="row">
                            <div class="bx-sub-title m-bold">Search</div>
                            <div class="col-lg-3">
                                <mat-form-field appearance="legacy" [style.width.%]="100">
                                    <input matInput placeholder="URN" [(ngModel)]="txtURN"><mat-label>URN</mat-label>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field appearance="legacy" [style.width.%]="100">
                                    <mat-label for="priority">Priority</mat-label>
                                    <mat-select [(ngModel)]="ddlPriority" id="priority" [attr.role]="null">
                                        <mat-option *ngFor="let option of lstPriority" [value]="option.value">
                                            {{ option.text }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <!-- <div class="col-lg-3">
                                <mat-form-field appearance="legacy" [style.width.%]="100">
                                    <mat-label>Input Type</mat-label><input matInput placeholder="Input Type" [(ngModel)]="txtInputType">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field appearance="legacy" [style.width.%]="100">
                                    <mat-label>Input From</mat-label><input matInput placeholder="Input From" [(ngModel)]="txtInputFrom">
                                </mat-form-field>
                            </div> -->
                            <div class="col-lg-3">
                                <mat-form-field [style.width.%]="100">
                                    <mat-label for="received_date_range">Received Date Range</mat-label>
                                    <mat-date-range-input [min]="commonService.minDate" [rangePicker]="picker"
                                        [formGroup]="invoiceCreationDateRange" id="received_date_range">
                                        <input matStartDate formControlName="start_date" #startdate
                                            placeholder="Start Date" [max]="maxDate"
                                            (dateChange)="onInvoiceCreationDateChanges()">
                                        <input matEndDate formControlName="end_date" #endDate placeholder="End Date"
                                            [max]="maxDate" (dateChange)="onInvoiceCreationDateChanges()">
                                    </mat-date-range-input>
                                    <button *ngIf="isDateRangeHasValue" mat-button matSuffix mat-icon-button
                                        (click)="resetInvoiceCreationDateRange()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker></mat-date-range-picker>
                                </mat-form-field>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<!-- <app-footer *ngIf="isDisplay"></app-footer> -->